import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';
import { theme } from '@marriott/mi-ui-library-shop';

export const StyledOffersSearchForm = styled.div`
  .error-message {
    border: ${toRem(1)} solid ${baseVariables.color.alert50};
    border-radius: ${toRem(8)};
    background-color: rgb(252, 235, 237);
    margin-top: ${toRem(16)};
    margin-bottom: ${toRem(10)};
    .m-message-inline.col-10 {
      flex: unset;
      max-width: 100%;
      border: none;
      background-color: rgb(252, 235, 237);
      padding: ${toRem(12)} ${toRem(20)};
    }
    .m-message-content-wrap {
      &:before {
        color: ${baseVariables.color.alert50};
      }
      color: ${baseVariables.color.alert50};
    }
    .row {
      margin-right: auto;
      margin-left: auto;
    }
  }
  .search-form-wrapper {
    box-shadow: none;
    border-radius: ${toRem(16)};
    background: none;
    label {
      margin-bottom: 0;
    }
  }
  &.sticky-search-container {
    position: fixed;
    width: 100%;
    left: 0;
    background: ${theme.color.white};
    margin-top: 0 !important;
    z-index: 1001;
    padding: 0 !important;
    /*
     * The initial (non-sticky) SPO layout uses \`position: absolute\` and a negative
     * \`margin-top\` on \`.offers-spo\` (see index.styles.tsx) so the search form overlaps
     * the hero. Once we go sticky, that negative margin pulls the inner content above
     * the fixed wrapper's top edge and into the AEM header, causing the overlap that is
     * most visible on mobile. Reset both properties while sticky so the content sits
     * inside the fixed wrapper at the JS-computed top offset.
     */
    .offers-spo {
      position: relative !important;
      margin-top: 0 !important;
      @media ${theme.mediaQuery.allMobiles} {
        padding: 0 !important;
        margin-top: 0 !important;
      }
    }
    /*
     * The initial layout applies \`.enable-overlap { position: relative; top: 22px; }\`
     * (and \`bottom: 1rem\` on mobileTablet) in index.styles.tsx so the search form
     * overlaps the hero. Once we go sticky, that relative offset pushes the inner
     * content 22px down from the fixed wrapper (which itself is pinned at the
     * JS-computed top), leaving a visible empty strip above the search form.
     * Reset the offset while sticky so the content sits flush inside the wrapper.
     */
    .enable-overlap {
      top: 0 !important;
      bottom: 0 !important;
    }
    /*
     * SearchDesktop/SearchMobile always render \`<div class="mpo-search-title">\`,
     * even for SPO where the div is empty. index.styles.tsx gives that div
     * \`margin-top: 62px; margin-bottom: 18px;\` on desktop and \`padding-top: 40px;
     * margin-bottom: 16px;\` on mobile. In the non-sticky SPO layout the negative
     * \`margin-top: -136px\` on \`.offers-spo\` hides that vertical space. Once sticky,
     * we reset that negative margin, so the empty title's margins/padding become
     * visible as an internal gap at the top of the container. Collapse them here
     * (sticky only runs for SPO, so the empty div is the only case).
     */
    .mpo-search-title {
      margin-top: 0 !important;
      margin-bottom: 0 !important;
      padding-top: 0 !important;
    }
    .search-primary {
      box-shadow: none;
    }
    .search-secondary {
      display: none;
    }
  }
  &.search-container-top {
    padding-top: ${toRem(16)} !important;
    @media ${theme.mediaQuery.desktop} {
      padding-top: ${toRem(32)} !important;
    }
  }
  &.sticky-search-top {
    position: fixed;
    width: 100%;
    left: 0;
    background: ${theme.color.white};
    margin-top: 0 !important;
    z-index: 30;
    transition: top 0.4s ease 0s;
    padding: 0 !important;
    /*
     * Same reason as \`.sticky-search-container\` above: reset the initial SPO overlap
     * offsets so the inner content stays inside the sticky wrapper instead of being
     * pulled up into the header while scrolling.
     */
    .offers-spo {
      position: relative !important;
      margin-top: 0 !important;
      @media ${theme.mediaQuery.allMobiles} {
        padding: 0 !important;
        margin-top: 0 !important;
      }
      .search-primary {
        box-shadow: none;
      }
      .search-secondary {
        display: none !important;
      }
    }
    /*
     * Same reason as \`.sticky-search-container\` above: neutralize the
     * \`.enable-overlap\` relative offset (top: 22px on tablet/desktop, bottom: 1rem
     * on mobileTablet) so the sticky-on-scroll-up state does not leave an empty
     * strip between the wrapper's top edge and the search form content.
     */
    .enable-overlap {
      top: 0 !important;
      bottom: 0 !important;
    }
    /*
     * Same reason as \`.sticky-search-container\`: the always-rendered empty
     * \`.mpo-search-title\` div carries top/bottom margins (and top padding on
     * mobile) that only stay hidden thanks to the non-sticky negative
     * \`margin-top\` on \`.offers-spo\`. Zero them out while sticky.
     */
    .mpo-search-title {
      margin-top: 0 !important;
      margin-bottom: 0 !important;
      padding-top: 0 !important;
    }
  }
`;
